import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetCategory } from "../../redux/slices/GetCategorySlice";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineArrowLeft } from "react-icons/ai";
import Footer from "../../Fotter";
import LoaderPage from "../Loader";
function ViewAllCategory() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { AllCategory } = useSelector((state) => state.category);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        await dispatch(GetCategory()).unwrap();
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [dispatch]);


  const _handleClick = (name) => {
    if (name?.subcategories?.length) {
      navigate(`/product-category/${name.name}/${name._id}`, {
        state: { name },
      });
    } else {
      setShowModal(true);
    }
  };

  return (
    <div className="flex flex-col min-h-screen ">
      <div className="flex-grow">
        <div className="sm:mt-5 flex mx-auto  items-center  w-[90%]   justify-between ">
          <button
            onClick={() => navigate(-1)}
            className="mr-2 bg-gray-200 px-2 py-2  rounded-full flex items-center "
          >
            <AiOutlineArrowLeft className="text-lg mr-1" />
          </button>
          <h1 className="text-lg m font-bold   text-center">
            View All Categories
          </h1>
          <h1></h1>
        </div>
        {loading ? (
          <LoaderPage />
        ) : (
          <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 xl:grid-cols-8 gap-5 mt-5  w-[95%] p-2 mx-auto">
            {AllCategory?.map((category, index) => (
              <div
                key={index}
                onClick={() => _handleClick(category)}
                className="flex flex-col items-center p-1 cursor-pointer rounded-lg bg-white hover:shadow-lg transition-shadow "
              >
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-16 h-16 rounded-full object-cover border border-gray-200"
                />
                <p className="text-center font-medium text-gray-700 line-clamp-1">
                  {category.name}
                </p>
              </div>
            ))}
          </div>
        )}
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 w-[300px] text-center shadow-lg">
              <h2 className="text-xl font-bold mb-2">Coming Soon</h2>
              <p className="text-gray-600 mb-4">Products for this category will be available soon</p>
              <button
                onClick={() => setShowModal(false)}
                className="mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Close
              </button>
            </div>
          </div>
        )}

      </div>
      <Footer />
    </div>
  );
}

export default ViewAllCategory;
